import { FormattedMessage } from "react-intl";

import { Empty } from "antd";

import { CmtSectionCard } from "@app/components/common/CmtSectionCard.tsx";
import { CmtRoleTag } from "@app/components/users/field/CmtRoleTag.tsx";

interface CmtUserRolesProps {
  roles: string[];
}

export const CmtUserRoles = ({ roles }: CmtUserRolesProps) => (
  <CmtSectionCard
    title={<FormattedMessage id="table.roles" defaultMessage="Roles" />}
    extra={roles.length}
  >
    {roles.length === 0 ? (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
    ) : (
      <div style={{ display: "flex", flexWrap: "wrap", gap: "0.375rem" }}>
        {[...roles].sort().map((role) => (
          <CmtRoleTag role={role} key={role} />
        ))}
      </div>
    )}
  </CmtSectionCard>
);
